export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/galen-crout-6dad13a8a22e8db833eedc12ea2039c0.jpg";